module.exports = __webpack_public_path__ + "img/scatter.e584cc8a.png";